import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "./layout/SideBar";
import { jwtDecode } from "jwt-decode";
import { handleUser, logout } from "./features/auth/authSlice";
import { useEffect, useRef, useState } from "react";
import axiosInstance, { setAxiosBaseURL } from "./instance";

export const ProtectedRoute = () => {
  const { isActive } = useSelector((state) => state.auth);
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const [selectedCounty, setSelectedCounty] = useState(
    localStorage.getItem("selectedCounty")
  );
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loc = useLocation();
  const token = localStorage.getItem("token");

  async function handleDecodeToken() {
    try {
      let tokenObj = jwtDecode(token);
      await dispatch(handleUser(tokenObj));
    } catch (error) {
      await dispatch(handleUser({}));
    }
  }

  async function handleLogout() {
    await dispatch(logout());
    localStorage.clear();
    navigate("/login");
  }

  const isTokenExpired = (token) => {
    if (!token) return true;

    const decodedToken = token?.length && jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decodedToken?.exp < currentTime;
  };

  useEffect(() => {
    if (!token || isTokenExpired(token)) {
      handleLogout();
    } else {
      handleDecodeToken();
    }
  }, [token, pathname]);

  useEffect(() => {
    axiosInstance.defaults.headers.common = {
      Authorization: `Bearer ${token}`, 
    };
  }, [token, isActive, selectedOrg, selectedCounty]);

  const baseURLRef = useRef(process.env.REACT_APP_API_BASE_URL);
  const [baseURL, setBaseURL] = useState(baseURLRef?.current);
  useEffect(() => {
    if (pathname.startsWith("/scheme") || pathname.startsWith("/user")) {
      baseURLRef.current = process.env.REACT_APP_API_BASE_SCHEME;
    } else if (pathname.startsWith("/rob")) {
      baseURLRef.current = process.env.REACT_APP_API_BASE_ROBOT;
    } else {
      baseURLRef.current = process.env.REACT_APP_API_BASE_URL;
    }
    axiosInstance.defaults.baseURL = baseURLRef?.current;
    setBaseURL(baseURLRef?.current);
  }, [pathname]);


  useEffect(() => {
  const handleStorageChange = () => {
    setSelectedOrg(localStorage.getItem("selectedOrg"));
    setSelectedCounty(localStorage.getItem("selectedCounty"));
  };

  window.addEventListener("storage", handleStorageChange);
  const interval = setInterval(handleStorageChange, 500);  

  return () => {
    window.removeEventListener("storage", handleStorageChange);
    clearInterval(interval);
  };
}, []);

  if (!isActive && !token) {
    return <Navigate to="/login" replace />;
  }
 

  return (
    <div className="min-h-screen w-full bg-[#F7F7F7] relative">
      <div className="flex items-start justify-start w-full h-full">
        <SideBar />
        <div
          className={`flex-1 mt-[60px] pt-[2.5rem] pb-[1.25rem] lg:px-[2.5rem] px-3 ${
            sideMenuCollapsed ? "" : "lg:ml-[256px]"
          }  overflow-auto`}
        >
          <Outlet key={`${selectedOrg}-${selectedCounty}`} />
        </div>
      </div>
    </div>
  );
};
